import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import {
  Judge,
  Nullable,
  UserWithToken,
  WithMeta,
} from '@ygoargentina/sdk/api/api.types';

export const listJudges = async (
  user: Nullable<UserWithToken>,
  variables: Record<string, unknown>
) =>
  getGraphQLQueryClient(user).request<WithMeta<Judge>>(
    gql`
      query ($filters: JudgeFilters) {
        data: judges(filters: $filters) {
          data {
            id
            rc
            pc
            dc

            user {
              name
              lastName
              cossyId
            }
          }
          meta {
            total
            perPage
            lastPage
          }
        }
      }
    `,
    { filters: variables }
  );
